import $public from '../../util/public.js'
export default {
	namespaced: true,
	state: {
		type:'list',
		addParams:{},
		money:0,
		huiyuanMoney:0,
		activityMoney:0,
		discountMoney:0,
		showVip:false,
		remark:'',
		curDiscountCard:null,
	},
	getters: {
		
	},
	mutations: {
		set_type(state, params) {
			state.type = params;
		},
		set_addParams(state, obj) {
			console.log(obj,'-------');
			let totalMoney = 0;
			let vipMoney=0;
			let activityMoney = 0;
			let showVip=false;
			for(let i=0;i<obj.length;i++){
				let total = 0;
				let activityTotal = 0;
				let vipTotal=0;
				for(let a=0;a<obj[i].tableData.length;a++){
					if(($public.isNull(obj[i].tableData[a].activityId)&&$public.isNull(obj[i].tableData[a].couponId)&&$public.isNull(obj[i].tableData[a].cardId))&&obj[i].tableData[a].skuItem.mprice>0){
						showVip=true;
						console.log(obj[i].tableData[a].skuItem,'obj[i].tableData[a].skuItem');
						vipTotal = $public.jia(vipTotal,obj[i].tableData[a].skuItem.mprice)
					}else{
						vipTotal = $public.jia(vipTotal,obj[i].tableData[a].skuItem.price)
					}
					total = $public.jia(total,obj[i].tableData[a].skuItem.originalPrice)
					activityTotal = $public.jia(activityTotal,obj[i].tableData[a].skuItem.price)
				}
				obj.total = total
				obj.vipTotal = vipTotal
				obj.activityTotal = activityTotal
				totalMoney = $public.jia(totalMoney,total)
				vipMoney = $public.jia(vipMoney,vipTotal)
				activityMoney = $public.jia(activityMoney,activityTotal)
			}
			state.money = totalMoney;
			state.huiyuanMoney = vipMoney;
			state.activityMoney = activityMoney;
			state.addParams = obj;
			state.curDiscountCard = null;
			state.discountMoney = 0;
			state.showVip=showVip;
			console.log(showVip,showVip);
		},
		set_money(state, params) {
			state.money = params;
		},
		set_vipMoney(state, params) {
			state.huiyuanMoney = params;
		},
		set_activityMoney(state, params) {
			state.activityMoney = params;
		},
		set_discountMoney(state, params) {
			state.discountMoney = params;
		},
		set_remark(state, obj) {
			state.remark = obj;
		},
		set_curDiscountCard(state, obj) {
			state.curDiscountCard = obj;
		},
	},
	actions: {

	},
};
